import { useContext, useEffect, useRef, useState } from "react";
import {
  CalcInput,
  ParagraphText,
  UBAppModal,
  UBButton,
  UBInput,
  UBRadioBox,
} from "../../../../Libraries";
import {
  AppCollectPayment,
  FileAttachment,
  NetCalculationCard,
  PaymentMethodToggle,
  RouteLeavingGuard,
  SelectAmountSummary,
  TitleAndActionBox,
} from "../../../common";
import { LanguageContext } from "../../../../context/LanguageContext";
import {
  Box,
  Chip,
  Grid,
} from "@mui/material";
import { useSnackbar } from "../../../../context/SnackbarContext";
import styles from "./styles.module.css";
import {
  camelCase,
  EMIONBOARDINGSTATUS,
  sentenceCase,
  updatedPaymentMethods,
  VERIFIED,
} from "../../../../constants";
import { useLocation, useNavigate } from "react-router-dom";
import withObservables from "@nozbe/with-observables";
import StockAddItem from "../../../common/StockAddItem";
import moment from "moment";
import { useAuthContext } from "../../../../context/AuthContext";
import { catchError, of, switchMap } from "rxjs";
import {
  blurAllInputField,
  formattedCount,
  getCategoriesByType,
  resolveCategoryDisplayName,
  removeRsFromValue,
  roundToTwoDecimalPlaces,
  sendToWhatsApp,
  validatePriceQtyInput,
} from "../../../../utils";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import { formatNum, uuid } from "../../../../oscar-pos-core/constants";
import { Sync } from "../../../../SyncService";
import { bulkUpdateStockV2 } from "../../../../database/helpers/stock";
import {
  bulkCreateOrdersV3,
  bulkDeleteOrders,
  bulkRestoreStock,
  bulkUpdateOrders,
  bulkUpdateTransactionStock,
} from "../../../../database/helpers/orders";
import {
  bulkCreateInventoryV3,
  bulkDeleteInventory,
  bulkUpdateInventory,
} from "../../../../database/helpers/inventory";
import {
  calculateTotalOutstanding,
  findCustomerByID,
} from "../../../../database/helpers/customer";
import {
  fetchQuickSaleCount,
  observeInvoicesById,
} from "../../../../database/helpers/invoice";
import AddCustomerModal from "../../../common/Modals/AddCustomerModal";
import { phoneNumRegex } from "../../../../validations";
import { BankIconNew, EnterIcon } from "../../../../assets/icons/icon";
import { Fragment } from "react";
import {
  bulkCreatePayments,
  bulkDeletePaymentsV2,
  getPaymentsByInvoiceExternal,
} from "../../../../database/helpers/payment";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { useDemoModeNavigation } from "../../../../hooks/useDemoNavigation";
import PaymentQRCode from "../PaymentQRCode";
import { useWalletContext } from "../../../../context/WalletContext";
import BusinessLoader from "../../../common/BusinessLoader";
import ExpandableWrapper from "../../../../Libraries/ExpandWrapper";
import {
  getConvertedDisountMehod,
  getPaymentMethodType,
} from "../../../Features/NewInvoiceBook/invoiceBookUtils";
import { WalletNonidealModal } from "../../../common/Modals";

const EnhancementSaleExpenseForm = ({
  invoiceDetail,
  orders,
  customerDetail,
  customers,
  type,
}) => {
  const { fetchAccountInfo, isAccountLoading, accountInfo } =
    useWalletContext();
  const raastDetail = accountInfo?.raast_info?.raast;
  const accountTitle = raastDetail?.raast_details?.name || "";
  const accountNumber = raastDetail?.raast_details?.account_number || "";
  const iban = raastDetail?.raast_details?.iban || "";
  const bank_name = raastDetail?.bank_name || "RUPIN";

  const isEMIVerified = accountInfo?.emi_onboarding_status == EMIONBOARDINGSTATUS.VERIFIED


  invoiceDetail = invoiceDetail?.length ? invoiceDetail[0] : null;
  const addedCustomer = customerDetail || undefined;
  const [I18n] = useContext(LanguageContext);
  const { user, business } = useAuthContext();
  const [isDirty, setDirty] = useState(false);
  const [itemObj, setItemObj] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [initName, setInitname] = useState("");
  const [initPhone, setInitphone] = useState("");
  const [createCustomerModal, setCreateCustomerModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [tempQuickSaleDetail, setTempQuickSaleDetail] = useState();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  const [state, setState] = useState({
    date: invoiceDetail?.transacted_at
      ? moment(invoiceDetail?.transacted_at)
      : moment(),
    note: invoiceDetail?.note || "",
    image: invoiceDetail?.image_url || "",
    items: [],
    category: invoiceDetail?.category || "",
    categoryLabel:
      resolveCategoryDisplayName(
        type === "in" ? "business_sale" : "business_expense",
        invoiceDetail?.category,
      ) || "",
    customer: customerDetail
      ? {
        id: customerDetail?.id,
        label: customerDetail?.name,
        value: customerDetail?.name,
        labelText: customerDetail?.name,
      }
      : null,
    status:
      invoiceDetail?.status === "paid"
        ? "Paid"
        : invoiceDetail?.status === "unpaid"
          ? "Unpaid"
          : "Paid",
  });
  const [balanceAmount, setBalanceAmount] = useState(null);

  const [totalDiscount, setTotalDiscount] = useState({
    edit: Boolean(invoiceDetail?.discount) || false,
    value: invoiceDetail?.discount || null,
    type: invoiceDetail?.discount_unit === "%" ? "%" : "rs",
  });
  const [totalTax, setTotalTax] = useState({
    edit: Boolean(invoiceDetail?.tax_rate) || false,
    value: invoiceDetail?.tax_rate || null,
  });
  const resolvePaymentMethod = (invoice) => {
    if (!invoice)
      return updatedPaymentMethods.find((m) => m.name === "bank") || null;
    return (
      getPaymentMethodType(invoice) ||
      (invoice.method
        ? updatedPaymentMethods.find(
          (m) => m.type === invoice.method || m.name === invoice.method,
        )
        : null) ||
      null
    );
  };

  const [receivedAmt, setReceivedAmt] = useState({
    edit: false,
    value: invoiceDetail?.advance_amount || null,
    paymentMethod: resolvePaymentMethod(invoiceDetail),
  });

  const [subTotalAmt, setSubTotalAmt] = useState(
    invoiceDetail?.sub_total ?? "",
  );
  const [netTotalAmt, setNetTotalAmt] = useState(
    invoiceDetail?.amount || invoiceDetail?.total || "",
  );

  const [pmtMethod, setPmtMethod] = useState(null);
  const [walletNonidealModal, setWalletNonidealModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  const inputAmountRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [files, setFiles] = useState(invoiceDetail?.attachment || []); // Tracks the files selected in FileAttachment
  const [addContact, setAddContact] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const { handleDemoNavigation } = useDemoModeNavigation();
  const isEditMode = Boolean(invoiceDetail);
  const isSale = type === "in";

  useEffect(() => {
    if (subTotalAmt === "" || subTotalAmt == null) return;

    const discDeduct =
      totalDiscount.type === "%"
        ? subTotalAmt * ((totalDiscount.value || 0) / 100)
        : totalDiscount.value || 0;

    const tot = +(subTotalAmt - discDeduct).toFixed(2);
    const taxAdd = +(tot * ((Number(totalTax.value) || 0) / 100)).toFixed(2);
    const val = roundToTwoDecimalPlaces(tot + taxAdd);

    setNetTotalAmt(val ?? null);
    setBalanceAmount(Math.max(tot + taxAdd - (receivedAmt?.value || 0), 0));
  }, [subTotalAmt, receivedAmt, totalDiscount, totalTax]);

  useEffect(() => {
    const total = netTotalAmt - (receivedAmt?.value || 0);
    if (total >= 0) {
      setBalanceAmount(total || 0);
    }
  }, [netTotalAmt, receivedAmt]);

  useEffect(() => {
    setTempQuickSaleDetail({ ...invoiceDetail?._raw });
  }, [invoiceDetail]);

  useEffect(() => {
    if (!invoiceDetail) return;
    setSubTotalAmt(invoiceDetail.sub_total || "");
    setNetTotalAmt(invoiceDetail.amount || invoiceDetail.total || "");
    setTotalDiscount({
      edit: Boolean(invoiceDetail.discount) || false,
      value: invoiceDetail.discount || null,
      type: invoiceDetail.discount_unit === "%" ? "%" : "rs",
    });
    setTotalTax({
      edit: Boolean(invoiceDetail.tax_rate) || false,
      value: invoiceDetail.tax_rate || null,
    });
    setReceivedAmt({
      edit: false,
      value: invoiceDetail.advance_amount || null,
      paymentMethod: resolvePaymentMethod(invoiceDetail),
    });
  }, [invoiceDetail?.id]);

  const onChangeText = (key, text) => {
    if (key === "amount") {
      if (validatePriceQtyInput(`${text}`, 9999999999999999)) {
        const result = removeRsFromValue(`${text}`);
        if (result.length >= 1 && subTotalAmt.length == 0 && !isEditMode)
          triggerLogEvent(
            analytics,
            isSale ? "quickSale_amount_start" : "exp_amount_start",
            {
              amount: text,
            },
          );

        setState((preState) => ({
          ...preState,
          paidAmount: "",
          [key]: result,
        }));
        setDirty(true);
      }
      return;
    } else if (key === "note") {
      if (text.length >= 1 && state.note.length == 0 && !isEditMode)
        triggerLogEvent(
          analytics,
          isSale ? "quickSale_note_start" : "exp_note_start",
          { amount: text },
        );
    }
    setDirty(true);
    setState((preState) => ({
      ...preState,
      [key]: text,
    }));
  };

  useEffect(() => {
    if (!accountInfo && user?.phone_number) fetchAccountInfo(navigate);
    if (inputAmountRef?.current) inputAmountRef.current.focus();
  }, [user]);

  useEffect(() => {
    if (orders?.length > 0) {
      const items = {};
      const itemsArr = [];

      orders.forEach((element) => {
        const obj = {
          cost_price: element.cost_price,
          id: element.stock.id,
          name: element.name,
          quantity: element.quantity,
          selling_price: element.selling_price,
        };
        items[element.stock.id] = obj;
        itemsArr.push(obj);
      });
      setItemObj(items);
      setState((e) => ({ ...e, items: itemsArr }));
    }
  }, [orders]);

  const handleEditTransactionItems = async (selectedItems) => {
    let toAdd = [],
      toEdit = [],
      toDelete = [];
    let orderMap = {};

    await Promise.all(orders.map(async (order) => {
      const matchingItem = selectedItems.find((i) => i.id === order.stock.id);

      if (matchingItem) {
        toEdit.push({ original: order, updated: matchingItem });
      } else {
        const stock = await order.stock.fetch();
        toDelete.push({ original: order, updated: stock });
      }

      orderMap[order.stock.id] = order;
    }));

    selectedItems.forEach((x) => {
      if (!orderMap[x.id]) {
        toAdd.push(x);
      }
    });

    // Handle adding new items
    if (toAdd.length) {
      const ordersByItemId = await bulkCreateOrdersV3(
        business,
        invoiceDetail,
        toAdd,
        type,
        type == "in" ? "quick_sale" : "quick_expense",
      );
      await bulkUpdateStockV2(toAdd, type);
      await bulkCreateInventoryV3(business, invoiceDetail, toAdd, type === "out" ? "in" : "out", "cash", ordersByItemId);
    }

    // Handle editing existing items
    if (toEdit.length) {
      await bulkUpdateTransactionStock(toEdit, type);
      await bulkUpdateInventory(business, invoiceDetail, toEdit, type, "cash");
      await bulkUpdateOrders(toEdit);
    }

    // Handle deleting items
    if (toDelete.length) {
      await bulkRestoreStock(toDelete, type);
      await bulkDeleteOrders(toDelete);
      await bulkDeleteInventory(invoiceDetail, toDelete, type, "cash");
    }
    if (selectedItems.length !== orders.length)
      triggerLogEvent(
        analytics,
        isSale ? "quickSale_edit_item" : "exp_edit_item",
      );
  };

  const onSave = async () => {
    if (Number(subTotalAmt) <= 0) {
      setError({ text: I18n.invalid_amount, show: true });
      return;
    }
    if (isLoading) return;
    setIsLoading(true);
    let { amount, category, date, image, items, note, customer } = state;
    try {
      const invoiceAmountObj = {
        discount: Number(totalDiscount?.value) || 0,
        discount_unit: totalDiscount?.type || "rs",
        tax_rate: Number(totalTax?.value) || 0,
        total: Number(netTotalAmt) || 0,
        sub_total: Number(subTotalAmt) || 0,
        advance_amount: Number(receivedAmt?.value) || 0,
        profit: 0,
      };

      const isPaidStatus = state.status.toLowerCase() === "paid";
      const pmtType =
        receivedAmt?.paymentMethod?.value || receivedAmt?.paymentMethod?.type;
      const pmtName =
        receivedAmt?.paymentMethod?.label || receivedAmt?.paymentMethod?.name;
      const finalObj = {
        method: isPaidStatus
          ? pmtType || "cash"
          : receivedAmt?.value
            ? pmtType || "cash"
            : "",
        bank: pmtType === "bank" ? pmtName || "bank" : "",
        wallet: pmtType === "wallet" ? pmtName || "" : "",
      };
      let partialAmount =
        invoiceAmountObj?.total - Number(invoiceAmountObj?.advance_amount || 0);

      const filteredItems = state.items.filter((item) => item.isNew);
      if (filteredItems.length) {
        await Promise.all(
          filteredItems.map(async (item) => {
            const convertedObj = {
              name: item.name,
              stock: 0,
              cost_price: Number(item.cost_price),
              selling_price: Number(item.selling_price),
              unit: "Pieces",
              id: item.id,
            };
            return await business
              .createStock(convertedObj)
              .then(async () => {
                triggerLogEvent(
                  analytics,
                  isEditMode
                    ? isSale
                      ? "quickSale_edit_item_created"
                      : "exp_edit_item_created"
                    : isSale
                      ? "quickSale_item_created"
                      : "exp_item_created",
                );
              })
              .catch((err) => {
                setIsLoading(false);
              });
          }),
        )
          .then(async (valu) => {
            await Sync(user?.phone_number, navigate);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }

      const nextExpCount = Number(business?.invoice_number_count || 0) + 1;

      let cust = null;
      if (customer?.id) {
        cust = await findCustomerByID(customer?.id);
      }
      const isUnPaid = state.status.toLocaleLowerCase() === "unpaid";
      let invoiceStatus = isUnPaid
        ? invoiceAmountObj?.total - Number(invoiceAmountObj?.advance_amount) < 1
          ? "paid"
          : "unpaid"
        : "paid";
      let invoiceData = {
        sales_amount: type == "in" ? invoiceAmountObj?.total : 0,
        cost_amount: type == "out" ? invoiceAmountObj?.total : 0,
        amount: invoiceAmountObj?.total,
        date: date || new Date(),
        customer: cust,
        image_url: "",
        document_url: "",
        signature: null,
        note: state.note,
        status: invoiceStatus,
        method: finalObj?.method || "cash",
        category,
        type,
        tranType: "cash",
        bank: finalObj?.bank,
        wallet: finalObj?.wallet,
        invoice_title: "",
        invoice_number: `${formattedCount(nextExpCount)}`,
        invoice_prefix: isSale ? "Sale#" : "EXP#",
        due_date: null,
        discount: Number(invoiceAmountObj?.discount) || 0,
        discount_unit: getConvertedDisountMehod(
          invoiceAmountObj?.discount_unit,
        ),
        tax_rate: Number(invoiceAmountObj?.tax_rate) || 0,
        total: Number(invoiceAmountObj?.total) || 0,
        sub_total: Number(invoiceAmountObj?.sub_total) || 0,
        advance_amount:
          invoiceStatus?.toLowerCase() == "paid"
            ? invoiceAmountObj?.total
            : invoiceAmountObj?.advance_amount || 0,
        profit: 0,
        partialAmount,
        attachment: files,
      };
      if (isEditMode) {
        if (invoiceData.customer && !addedCustomer)
          await handleCreateCustomerPayment(
            business,
            invoiceData.customer,
            invoiceData,
            invoiceDetail,
          );
        else if (invoiceData.customer) {
          let dataForPayment = {
            udhaar_note: invoiceData?.note,
            date: invoiceData?.date || new Date(),
            image_url: invoiceData?.image_url || null,
            invoiceDetail,
            type: "cashbook",
          };

          // if total amount is changed, create or update the full payment entry
          if (invoiceData.amount != invoiceDetail?.amount) {
            const fullPaymentData = {
              ...dataForPayment,
              amount: invoiceData.amount,
            };
            let invoicePayment = await getPaymentsByInvoiceExternal(
              invoiceDetail?.id,
              "full_invoice",
            );

            if (invoicePayment.length) {
              await invoicePayment[0]?.updatePayment(fullPaymentData);
            } else {
              await invoiceData.customer.createPayment({
                ...fullPaymentData,
                uid: uuid(),
                date: new Date(),
                payment_mode: type == "in" ? "Udhaar" : "Jama",
                external_type: "full_invoice",
              });
            }
          }

          // if advance/partial amount is changed, create or update the partial payment entry
          if (
            Number(invoiceDetail?.advance_amount) !==
            Number(invoiceData?.advance_amount)
          ) {
            const partialPaymentData = {
              ...dataForPayment,
              amount: Number(invoiceData?.advance_amount),
            };
            let invoicePayment = await getPaymentsByInvoiceExternal(
              invoiceDetail?.id,
              "partial_invoice",
            );

            if (invoicePayment.length) {
              await invoicePayment[0]?.updatePayment(partialPaymentData);
            } else if (Number(invoiceData?.advance_amount) > 0) {
              await invoiceData.customer.createPayment({
                ...partialPaymentData,
                uid: uuid(),
                date: new Date(),
                payment_mode: type == "in" ? "Jama" : "Udhaar",
                external_type: "partial_invoice",
              });
            }
          } else if (invoiceStatus == "paid") {
            // in case when invoiceDetail is paid, we are marking partial payment settled
            const partialPaymentData = {
              ...dataForPayment,
              amount: Number(invoiceData?.advance_amount),
            };
            let invoicePayment = await getPaymentsByInvoiceExternal(
              invoiceDetail?.id,
              "partial_invoice",
            );

            if (invoicePayment.length) {
              await invoicePayment[0]?.updatePayment(partialPaymentData);
            } else {
              await invoiceData.customer.createPayment({
                ...partialPaymentData,
                uid: uuid(),
                date: new Date(),
                payment_mode: type == "in" ? "Jama" : "Udhaar",
                external_type: "partial_invoice",
              });
            }
          }

          let totalOutstanding = await calculateTotalOutstanding(
            invoiceData.customer,
          );

          await invoiceData.customer.updateTotalOutstanding(totalOutstanding);
        }
        await invoiceDetail.updateInvocie(invoiceData);
        await handleEditTransactionItems(state.items, "payment");
        if (invoiceData.amount != tempQuickSaleDetail.amount)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_edit_amount" : "exp_edit_amount",
          );
        if (invoiceData.category != tempQuickSaleDetail.category)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_edit_category" : "exp_edit_category",
          );
        if (invoiceData?.company?.id != tempQuickSaleDetail.company_id)
          triggerLogEvent(
            analytics,
            isSale
              ? "quick_sale_edit_paid_to_company"
              : "exp_edit_paid_to_company",
          );
        if (invoiceData?.customer?.id != tempQuickSaleDetail?.customer_id)
          triggerLogEvent(
            analytics,
            isSale
              ? "quick_sale_edit_paid_to_supplier"
              : "exp_edit_paid_to_supplier",
          );
        if (invoiceData.image_url != tempQuickSaleDetail.image_url)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_edit_image" : "exp_edit_image",
          );
        if (tempQuickSaleDetail.image_url && !invoiceData.image_url)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_edit_image_deleted" : "exp_edit_image_deleted",
          );
        if (
          !moment(invoiceData.date).isSame(
            moment(tempQuickSaleDetail?.transacted_at),
          )
        )
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_edit_date" : "exp_edit_date",
          );
        if (invoiceData.note != tempQuickSaleDetail.note)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_edit_note" : "exp_edit_note",
          );
        if (invoiceData.advance_amount != tempQuickSaleDetail.advance_amount)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_edit_paid_amount" : "exp_edit_paid_amount",
          );
        if (invoiceData.method != tempQuickSaleDetail.method)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_edit_paid_through" : "exp_edit_paid_through",
          );
        triggerLogEvent(
          analytics,
          isSale ? "quick_sale_edited" : "exp_edited",
          {
            params: state,
          },
        );

        setDirty(false);
        Sync(user?.phone_number, navigate);
        setIsLoading(false);
        showSnackbar({
          message: isSale
            ? I18n.quickSale_has_been_successfully_updated
            : I18n.expense_has_been_successfully_updated,
          severity: "success",
        });
        setTimeout(
          () =>
            navigate(
              location?.state?.pathname
                ? location?.state?.pathname
                : isSale
                  ? `/Sales/QuickSale`
                  : `/Expenses`,
              {
                state: { saleMode: isSale ? "quick_sale" : "expense" },
              },
            ),
          1000,
        );
      } else {
        invoiceData["id"] = uuid();

        let invoice = await business.createInvoice(invoiceData);
        if (items.length) {
          const ordersByItemId = await bulkCreateOrdersV3(
            business,
            invoice,
            items,
            type,
            type == "in" ? "quick_sale" : "quick_expense",
          );

          await bulkUpdateStockV2(state.items, type);
          await bulkCreateInventoryV3(business, invoice, items, type === "out" ? "in" : "out", "cash", ordersByItemId);
          if (invoiceData.amount) triggerLogEvent(analytics, "quick_sale_item");
        }
        await business.updateBusinessInvoiceNo(nextExpCount);
        if (
          invoiceData.customer &&
          state.status.toLocaleLowerCase() == "unpaid"
        ) {
          const data = {
            amount: invoiceData.amount,
            date: invoiceData.date,
            image_url: invoiceData.image_url,
            note: invoiceData.note,
            advance_amount: invoiceData.advance_amount,
          };
          await handleCreateCustomerPayment(
            business,
            invoiceData.customer,
            data,
            invoice,
          );
        }
        if (invoiceData.amount)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_amount" : "exp_amount",
          );
        if (invoiceData.category)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_category" : "exp_category",
          );
        if (invoiceData.company)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_paid_to_company" : "exp_paid_to_company",
          );
        if (invoiceData.customer)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_paid_to_supplier" : "exp_paid_to_supplier",
          );
        if (invoiceData.image_url)
          triggerLogEvent(analytics, isSale ? "quick_sale_image" : "exp_image");
        if (invoiceData.date)
          triggerLogEvent(analytics, isSale ? "quick_sale_date" : "exp_date");
        if (invoiceData.note)
          triggerLogEvent(analytics, isSale ? "quick_sale_note" : "exp_note");
        if (invoiceData.advance_amount)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_paid_amount" : "exp_paid_amount",
          );
        if (invoiceData.method)
          triggerLogEvent(
            analytics,
            isSale ? "quick_sale_paid_through" : "exp_paid_through",
          );

        triggerLogEvent(
          analytics,
          isSale ? "quick_sale_created" : "exp_created",
          { params: state },
        );
        const quickSaleCount = await fetchQuickSaleCount();
        if (quickSaleCount === 5)
          triggerLogEvent(analytics, isSale ? "quick_sale_pu" : "exp_pu");

        setDirty(false);
        Sync(user?.phone_number, navigate);
        // setIsLoading(false);
        showSnackbar({
          message: isSale
            ? I18n.quickSale_has_been_successfully_recorded
            : I18n.expense_has_been_successfully_recorded,
          severity: "success",
        });

        handleDemoNavigation(
          location?.state?.pathname
            ? location?.state?.pathname
            : isSale
              ? "quick_sale"
              : "expense",
          location?.state?.pathname
            ? location?.state?.pathname
            : isSale
              ? `/Sales/QuickSale`
              : "/Expenses",
          { saleMode: isSale ? "quick_sale" : "expense" },
          1000,
        );
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleCreateCustomerPayment = async (
    business,
    customer,
    data,
    invoice,
  ) => {
    let payObj = {
      date: data?.date || new Date(),
      note: data?.note || "",
      image_url: data?.image_url || "",
      type: "cashbook",
    };

    let paymentArr = [
      {
        ...payObj,
        uid: uuid(),
        amount: data.amount,
        payment_mode: type == "in" ? "Udhaar" : "Jama",
        external_type: "full_invoice",
      },
    ];

    if (data?.advance_amount > 0) {
      paymentArr.push({
        ...payObj,
        uid: uuid(),
        amount: Number(data.advance_amount),
        payment_mode: type == "in" ? "Jama" : "Udhaar",
        external_type: "partial_invoice",
      });
    }

    await bulkCreatePayments(business, customer, invoice, paymentArr);

    let totalOutstanding = await calculateTotalOutstanding(customer);

    await customer.updateTotalOutstanding(totalOutstanding);
    await customer.updateLastTransactionDate();
  };
  const handleAddItem = (items) => {
    setDirty(true);
    setState((e) => ({ ...e, items }));
  };

  const openCreateCustomerModal = (value) => {
    triggerLogEvent(
      analytics,
      isSale
        ? "quick_sale_paid_to_supplier_created"
        : "exp_paid_to_supplier_created",
    );
    if (value?.match?.(phoneNumRegex) === null) {
      setInitname(value);
      setInitphone("");
    } else {
      setInitphone(value);
      setInitname("");
    }
    setCreateCustomerModal(true);
  };

  const handleCreateSupplier = (name, type) => {
    openCreateCustomerModal(name);
  };

  const handleAddCustomer = (payload) => {
    setCreateCustomerModal(false);
    setState((e) => ({
      ...e,
      customer:
        {
          id: payload.id,
          label: payload.name,
          labelText: payload.name,
          value: payload.name,
        } || "",
    }));
  };

  const isDisabled =
    subTotalAmt == null ||
    subTotalAmt === "" ||
    Number(subTotalAmt) <= 0 ||
    isLoading;
  const isDisplayRemainingSection =
    (subTotalAmt != null && subTotalAmt !== "" && Number(subTotalAmt) > 0) ||
    state.items.length > 0;
  useEffect(() => {
    if (open && !isDisplayRemainingSection) setOpen(false);
  }, [isDisplayRemainingSection, open]);
  useEffect(() => {
    setCategoryList(getCategoriesByType(isSale ? "business_sale" : "business_expense"));
  }, [isSale]);

  const handleDelete = async () => {
    setIsDeleteLoading(true);
    if (orders.length) {
      let toDelete = [];
      await Promise.all(
        orders.map(async (item) => {
          let stock = await item.stock.fetch();

          toDelete.push({
            original: item,
            updated: stock,
          });
        }),
      );

      if (toDelete.length) {
        await bulkRestoreStock(toDelete, invoiceDetail.type);
        await bulkDeleteOrders(toDelete);
      }
    }
    if (customerDetail) {
      let payments = await invoiceDetail.payment.fetch();
      await bulkDeletePaymentsV2(payments);

      let total = await calculateTotalOutstanding(customerDetail);
      await customerDetail.updateTotalOutstanding(total);
    }

    await invoiceDetail.markAsDeleted();
    setIsDeleteLoading(false);

    Sync(user.phone_number, navigate);
    showSnackbar({
      message: I18n.transaction_deleted,
      severity: "success",
      icon: "",
    });

    navigate(
      location?.state?.pathname
        ? location?.state?.pathname
        : isSale
          ? "/Sales/QuickSale"
          : "/Expenses",
      {
        state: { saleMode: isSale ? "quick_sale" : "expense" },
      },
    );
  };

  useEffect(() => {
    setContactList([
      ...customers.map((item) => {
        return {
          id: item.id,
          labelText: item.name,
          label: (
            <ParagraphText className={styles.contactLabel}>
              <span className="newFontColor">{item.name}</span>
              <span className="newLightColor">
                {item?.is_supplier ? "Supplier" : "Customer"}
              </span>
            </ParagraphText>
          ),
          value: item.name,
        };
      }),
    ]);
  }, [customers]);

  const handleViewQR = (bool) => {
    setOpen(bool);
  };
  const handleGetQR = () => {
    setDirty(false);
    setTimeout(() => navigate("/WalletOnboarding"), 100);
  };
  const handleAddContact = () => {
    setAddContact(true);
  };

  const handleReceivedAmount = (totalAmt) => {
    setDirty(true);
    if (validatePriceQtyInput(totalAmt, 9999999999)) {
      const result = removeRsFromValue(totalAmt);
      if (result.length >= 1 && receivedAmt.value == 0 && !isEditMode)
        triggerLogEvent(
          analytics,
          type == "in" ? "inv_recieve_start" : "pb_paid_start",
        );
      const total = netTotalAmt - (result || 0);
      if (total >= 0)
        setReceivedAmt((rcv) => ({
          ...rcv,
          value: result,
        }));
      else {
        setReceivedAmt((rcv) => ({
          ...rcv,
          value: netTotalAmt,
        }));
        showSnackbar({
          message: I18n.balance_amount_error,
          severity: "error",
        });
      }
    }
  };
  const updateNetTotalAmt = (subTotalAmt, totalDiscount, totalTax) => {
    let discValue = Number(totalDiscount.value) || 0;
    let taxValue = Number(totalTax.value) || 0;
    const discDeduct =
      (totalDiscount.type || totalDiscount.valueMethod) === "%"
        ? +subTotalAmt * (discValue / 100)
        : discValue;
    const tot = +(+subTotalAmt - discDeduct).toFixed(2);
    const taxAdd = +(tot * (taxValue / 100)).toFixed(2);
    const val = roundToTwoDecimalPlaces(tot + taxAdd);
    setNetTotalAmt(val ?? null);
    return val;
  };
  const handleTotalTax = (updatedTax) => {
    setDirty(true);
    setTotalTax((tx) => ({ ...tx, value: updatedTax.value }));
    const newNet = updateNetTotalAmt(subTotalAmt, totalDiscount, updatedTax);
    if (Number(newNet) < Number(receivedAmt?.value || 0)) {
      setReceivedAmt((prev) => ({ edit: false, value: "", paymentMethod: prev?.paymentMethod }));
      showSnackbar({ message: I18n.balance_amount_error, severity: "error" });
    }
  };
  const handleTotalDiscount = (updatedDiscount) => {
    setDirty(true);
    setTotalDiscount((tx) => ({ ...tx, value: updatedDiscount.value }));
    const newNet = updateNetTotalAmt(subTotalAmt, updatedDiscount, totalTax);
    if (Number(newNet) < Number(receivedAmt?.value || 0)) {
      setReceivedAmt((prev) => ({ edit: false, value: "", paymentMethod: prev?.paymentMethod }));
      showSnackbar({ message: I18n.balance_amount_error, severity: "error" });
    }
  };
  const handleNetTotal = (netTotal) => {
    setDirty(true);
    setError("");
    const result = removeRsFromValue(netTotal);
    const total = (Number(result) || 0) - (receivedAmt.value || 0);
    setNetTotalAmt(result === "" ? null : (result ?? null));
    setSubTotalAmt(result);
    setTotalDiscount((x) => ({
      ...x,
      edit: false,
      value: 0,
    }));
    setTotalTax((x) => ({
      ...x,
      edit: false,
      value: 0,
    }));
  };

  const handleSendMoney = () => {
    if (netTotalAmt == 0 || !netTotalAmt) {
      showSnackbar({
        message: I18n.amount_required_to_send_money,
        severity: "error",
      });
      return;
    }

    if (!isEMIVerified) {
      setDirty(false);
      setTimeout(() => navigate("/WalletOnboarding"), 100);
      return;
    }

    const isVerifiedAccountForWallet =
      accountInfo?.emi_onboarding_status === EMIONBOARDINGSTATUS.VERIFIED &&
      accountInfo?.verified === VERIFIED.VERIFIED;

    if (isEditMode) {
      const invoiceUpdatePayload = {
        mode: "edit_form",
        invoiceId: invoiceDetail.id,
        amountToSend: Number(netTotalAmt) - (invoiceDetail.advance_amount || 0),
        currentAdvanceAmount: invoiceDetail.advance_amount || 0,
        previousAmount: invoiceDetail.amount,
        addedCustomer: Boolean(addedCustomer),
        amount: Number(netTotalAmt),
        sales_amount: type === "in" ? Number(netTotalAmt) : 0,
        cost_amount: type === "out" ? Number(netTotalAmt) : 0,
        sub_total: Number(subTotalAmt) || 0,
        discount: Number(totalDiscount?.value) || 0,
        discount_unit: getConvertedDisountMehod(totalDiscount?.type || "rs"),
        tax_rate: Number(totalTax?.value) || 0,
        total: Number(netTotalAmt) || 0,
        note: state.note,
        category: state.category,
        date: state.date?.toISOString
          ? state.date.toISOString()
          : new Date().toISOString(),
        customerId: state.customer?.id || null,
        type,
        attachment: files,
        items: state.items,
        invoice_number: invoiceDetail.invoice_number,
        invoice_prefix: invoiceDetail.invoice_prefix,
        invoice_title: invoiceDetail.invoice_title,
        document_url: invoiceDetail.document_url,
        signature: invoiceDetail.signature,
        tax_title: invoiceDetail.tax_title,
        image_url: invoiceDetail.image_url,
        recording_uri: invoiceDetail.recording,
      };
      setDirty(false);
      setTimeout(
        () =>
          navigate(isVerifiedAccountForWallet ? "/UCash/SendMoney" : "/WalletOnboarding", {
            state: { invoiceUpdatePayload, backPath: "/Expenses" },
          }),
        100,
      );
      return;
    }

    const expensePayload = {
      amount: Number(netTotalAmt) || 0,
      subTotal: Number(subTotalAmt) || 0,
      discount: Number(totalDiscount?.value) || 0,
      discountUnit: totalDiscount?.type || "rs",
      taxRate: Number(totalTax?.value) || 0,
      note: state.note,
      category: state.category,
      date: state.date?.toISOString
        ? state.date.toISOString()
        : new Date().toISOString(),
      status: state.status,
      customerId: state.customer?.id || null,
      items: state.items,
      type,
      files,
    };

    setDirty(false);
    setTimeout(
      () =>
        navigate(isVerifiedAccountForWallet ? "/UCash/SendMoney" : "/WalletOnboarding", {
          state: { expensePayload, backPath: "/Expenses" },
        }),
      100,
    );
  };
  let top2Cate = [...categoryList];
  top2Cate = top2Cate.splice(0, 2);

  const showCollectPayment =
    !Boolean(isEditMode && addedCustomer) &&
    state.status.toLocaleLowerCase() !== "Unpaid" &&
    (receivedAmt?.paymentMethod?.name ||
      receivedAmt?.paymentMethod?.type ||
      null) === "bank";

  return (
    <Grid
      container
      className={`${styles.root} ${styles.SaleExpenseFormWrapper} SaleExpenseForm`}
    >
      <BusinessLoader loadBusiness={isAccountLoading} />
      <Grid item md={12}>
        <TitleAndActionBox
          data={{
            id: isSale ? "qucik_sale" : "expence",
            title: invoiceDetail
              ? isSale
                ? "edit_quicksale"
                : "edit_expenses"
              : isSale
                ? "record_new_quick_sale"
                : "record_new_quick_expense",
            isBack: true,
            onBack: () =>
              navigate(
                location?.state?.pathname
                  ? location?.state?.pathname
                  : isSale
                    ? "/Sales/QuickSale"
                    : "/Expenses",
                {
                  state: {
                    fromExpenseCreate: !location?.state?.isFullContainer,
                    saleMode: isSale ? "quick_sale" : "expense",
                  },
                },
              ),
          }}
        />

        <Box className={styles.formBodyGrid}>
          <Box className={`${styles.formColumn}`}>
            <Box
              className={`${styles.formBody} expenseFormBody`}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.shiftKey) {
                  e.preventDefault();
                  if (!isLoading && subTotalAmt) {
                    blurAllInputField();
                    onSave();
                  }
                }
              }}
            >
              <Box className={styles.expenseAmountInputBox}>
                <CalcInput
                  inputId={isSale ? "qucik_sale_amount" : "expence_amount"}
                  baseClassname={styles.amountInput}
                  placeholder={I18n.amount}
                  onChange={(key, value) => handleNetTotal(value)}
                  label={sentenceCase(I18n.enter_amount_trans)}
                  name={"amount"}
                  error={error}
                  required
                  value={netTotalAmt ?? ""}
                  inputRef={inputAmountRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !isDisabled) {
                      blurAllInputField();
                      onSave();
                    }
                  }}
                />
              </Box>
              {isDisplayRemainingSection || invoiceDetail ? (
                <Fragment>
                  <Box className={styles.paymentStatusBoxWrapper}>
                    <Box className={styles.paymentStatusBox}>
                      <Box className={styles.paymentStatusBoxLeft}>
                        <UBRadioBox
                          label={"Paid"}
                          displayLabel={I18n.paid}
                          onChange={(value) => {
                            setDirty(true);
                            triggerLogEvent(
                              analytics,
                              isSale ? "qucik_sale_paid" : "expense_paid",
                              {
                                type: value,
                              },
                            );
                            setState((preState) => ({
                              ...preState,
                              status: value,
                            }));
                            if (!receivedAmt?.paymentMethod) {
                              const bankMethod = updatedPaymentMethods.find(
                                (m) => m.name === "bank",
                              );
                              setReceivedAmt((e) => ({
                                ...e,
                                paymentMethod: bankMethod || null,
                              }));
                            }
                          }}
                          value={state.status}
                        />
                        <UBRadioBox
                          label={"Unpaid"}
                          displayLabel={I18n.unpaid}
                          onChange={(value) => {
                            setDirty(true);
                            triggerLogEvent(
                              analytics,
                              isSale ? "qucik_sale_unpaid" : "expense_unpaid",
                              {
                                type: value,
                              },
                            );
                            setState((preState) => ({
                              ...preState,
                              status: value,
                            }));
                          }}
                          value={state.status}
                        />
                      </Box>
                      <Box className={styles.paymentStatusBoxRight}>
                        <PaymentMethodToggle
                          visible={
                            state.status.toLocaleLowerCase() === "paid"
                          }
                          value={
                            receivedAmt?.paymentMethod?.name ||
                            receivedAmt?.paymentMethod?.type ||
                            null
                          }
                          onChange={(method) => {
                            setReceivedAmt((e) => ({
                              ...e,
                              paymentMethod: method,
                            }));
                            handleViewQR(false);
                          }}
                        />
                      </Box>
                    </Box>
                    <AppCollectPayment
                      visible={true}
                      status={state.status}
                      hasRaastDetail={!!isEMIVerified}
                      onViewQR={() => handleViewQR(true)}
                      onGetQR={() => handleGetQR()}
                      onAddContact={
                        isSale || state.status == "Unpaid"
                          ? handleAddContact
                          : handleSendMoney
                      }
                      customMessage={
                        !isSale
                          ? I18n.make_payment_with_bank_transfer
                          : null
                      }
                      customLinkText={!isSale ? I18n.send_money : null}
                      contactValue={state?.customer?.labelText || ""}
                      isSale={isSale}
                    />
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    className={`${styles.formBodyGridRow} ${styles.GridRowCategoryNotes}`}
                  >
                    <Grid item md={12}>
                      <Box
                        className={`${styles.tabAutoCompleteBox} ${styles.categoryAutoComplete} tabAutoCompleteBox categoryAutoComplete`}
                      >
                        <TabAutoComplete
                          id={
                            isSale ? "quick_sale_category" : "expence_category"
                          }
                          list={categoryList}
                          label={I18n.category_pl_tracking}
                          handleSelect={(item) => {
                            setState((e) => ({
                              ...e,
                              category: item?.id || "",
                              categoryLabel: item?.label || "",
                            }));
                          }}
                          value={state.categoryLabel}
                          placeholder={
                            isSale
                              ? I18n.select_sales_category
                              : I18n.select_expense_category
                          }
                          handleStartLogEvent={
                            isEditMode
                              ? () => { }
                              : () =>
                                triggerLogEvent(
                                  analytics,
                                  isSale
                                    ? "quick_sale_category_start"
                                    : "exp_category_start",
                                )
                          }
                          handleManuallyInput={() => setCategoryOpen(false)}
                          manuallyFocusInput={categoryOpen}
                        />

                        <Box className={styles.categoryInputBoxChip}>
                          {top2Cate.length > 1 &&
                            top2Cate.map((item) => (
                              <Chip
                                onClick={() =>
                                  setState((e) => ({
                                    ...e,
                                    category: item?.id || "",
                                    categoryLabel: item?.label || "",
                                  }))
                                }
                                className={styles.categoryInputBoxChipItem}
                                label={item.label}
                              />
                            ))}
                          <span
                            onClick={() => setCategoryOpen(true)}
                            className="cursorPointer barclayBlueColor fontSize12 textDecorationUnerline"
                          >
                            {I18n.see_more}
                          </span>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item md={12}>
                      <Box className={styles.noteInputBox}>
                        <UBInput
                          inputId={isSale ? "qucik_sale_note" : "expence_note"}
                          name="note"
                          label={I18n.notes}
                          placeholder={I18n.note_placeholder}
                          onChange={onChangeText}
                          value={state.note}
                          multiline
                          rows={1}
                          maxLength={500}
                          baseClassname={styles.noteInput}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Box
                    className={`${styles.tabAutoCompleteBox} tabAutoCompleteBox`}
                  >
                    <TabAutoComplete
                      id="quick_contactlist"
                      list={contactList}
                      label={I18n.contact}
                      handleSelect={(item) => {
                        setState((e) => ({
                          ...e,
                          customer: item || "",
                        }));
                      }}
                      value={state?.customer?.labelText || ""}
                      handleCreate={handleCreateSupplier}
                      asCreate={"contact"}
                      placeholder={I18n.select_a_contact}
                      disabled={Boolean(customerDetail?.id)}
                      handleStartLogEvent={
                        isEditMode
                          ? () => { }
                          : () =>
                            triggerLogEvent(
                              analytics,
                              "qucik_sale_paid_to_start",
                            )
                      }
                      manuallyFocusInput={addContact}
                      handleManuallyInput={() => setAddContact(false)}
                    />
                  </Box>
                  <Box className={styles.attachmentAndDateStyle}>
                    <FileAttachment
                      id="qucik_sale_file"
                      filesPath={files}
                      setFilesPath={(f) => {
                        setDirty(true);
                        setFiles(f);
                      }}
                      handleLogEvent={
                        isEditMode
                          ? () => { }
                          : () =>
                            triggerLogEvent(
                              analytics,
                              isSale
                                ? "quick_sale_photo_start"
                                : "expense_photo_start",
                            )
                      }
                      showDate
                      selectedDate={state.date}
                      setSelectedDate={(date) => {
                        setState((e) => ({ ...e, date }));
                        setDirty(true);
                      }}
                      datePlaceholder={I18n.select_date}
                      isEditMode={isEditMode}
                      handleDateLogEvent={() =>
                        triggerLogEvent(
                          analytics,
                          isSale
                            ? "quick_sale_date_start"
                            : "expense_date_start",
                        )
                      }
                    />
                  </Box>
                  <Box className={styles.addItemBox}>
                    <StockAddItem
                      id="quick_sale"
                      itemObj={itemObj}
                      handleAddItem={handleAddItem}
                      updateAmountWithTotal={(total) =>
                        handleNetTotal(String(total))
                      }
                      isITook={type === "out"}
                      handleStartLogEvent={
                        isEditMode
                          ? () => { }
                          : () =>
                            triggerLogEvent(
                              analytics,
                              isSale
                                ? "qucik_sale_item_start"
                                : "expense_item_start",
                            )
                      }
                    />
                  </Box>
                  <ExpandableWrapper
                    id="qucik_sale_expandable"
                    title={I18n.add_details}
                    className={"additionalDetailsWrapper"}
                    expanded={expanded}
                    setExpanded={setExpanded}
                  >
                    <NetCalculationCard
                      subTotalAmt={subTotalAmt}
                      totalDiscount={totalDiscount}
                      setTotalDiscount={(paload) => setTotalDiscount(paload)}
                      handleTotalDiscount={handleTotalDiscount}
                      totalTax={totalTax}
                      setTotalTax={(paload) => setTotalTax(paload)}
                      handleTotalTax={handleTotalTax}
                      totalAmount={+subTotalAmt}
                      handleDiscountLogEvent={
                        isEditMode
                          ? () => { }
                          : () =>
                            triggerLogEvent(
                              analytics,
                              type == "in"
                                ? "quickSale_discount_start"
                                : "quickExpense_discount_start",
                            )
                      }
                      handleTaxLogEvent={
                        isEditMode
                          ? () => { }
                          : () =>
                            triggerLogEvent(
                              analytics,
                              type == "in"
                                ? "quickSale_tax_start"
                                : "quickExpense_tax_start",
                            )
                      }
                      isEditMode={isEditMode}
                      children={
                        <SelectAmountSummary
                          selectAmountType={type == "out" ? "purchase" : "sale"}
                          pmtMethod={pmtMethod}
                          setPmtMethod={(paload) => setPmtMethod(paload)}
                          setReceivedAmt={(paload) => setReceivedAmt(paload)}
                          receivedAmt={receivedAmt}
                          handleReceivedAmount={handleReceivedAmount}
                          netTotalAmt={netTotalAmt}
                          balanceAmount={balanceAmount}
                          ItemList={state.items}
                          type={type}
                          isRecievedAmountField={
                            state.status.toLocaleLowerCase() === "unpaid"
                          }
                          handlePaymentLogEvent={
                            isEditMode
                              ? () => { }
                              : () =>
                                triggerLogEvent(
                                  analytics,
                                  type == "in"
                                    ? "quicksale_payment_start"
                                    : "quick_expense_payment_start",
                                )
                          }
                        />
                      }
                    />
                  </ExpandableWrapper>
                </Fragment>
              ) : null}
              <UBButton
                id={isSale ? "save_qucik_sale" : "save_expence"}
                title={<ParagraphText>{I18n.save} </ParagraphText>}
                loading={isLoading}
                iconComponent={<EnterIcon />}
                iconPlacement="right"
                disabled={isDisabled || isLoading}
                className={"buttonPrimary saveSaleButton"}
                onClick={onSave}
              />
            </Box>
          </Box>
          <Box className={`${styles.qrColumn}`}>
            {open && (
              <Box className={styles.qrCardAnimated}>
                <PaymentQRCode
                  accountInfo={accountInfo}
                  handleClose={() => setOpen(false)}
                  isModal={true}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      <RouteLeavingGuard
        id={isSale ? "quick_sale" : "expense"}
        when={isDirty}
        confirmText={
          isSale ? I18n.discard_quick_sale_btn : I18n.discard_expense_btn
        }
        title={
          isSale
            ? I18n.are_you_sure_you_want_to_delete_this_quick_sale
            : I18n.are_you_sure_you_want_to_delete_this_expense
        }
        message={I18n.this_action_cannot_be_undone}
      />
      <AddCustomerModal
        isOpen={createCustomerModal}
        handleClose={(v) => {
          setCreateCustomerModal(false);
        }}
        initialName={initName}
        initialPhone={initPhone}
        onSaveCallback={handleAddCustomer}
        title={
          <ParagraphText className={"ms-1 textLowercase"}>
            {I18n.customer}
          </ParagraphText>
        }
        isTypeField={true}
        className={"customer-selector-create-modal"}
        handleLogEventCustomerCreated={() =>
          triggerLogEvent(
            analytics,
            isSale ? `qucik_sale_customer_created` : "exp_customer_created",
          )
        }
        handleLogEventCustomerUpdate={() =>
          triggerLogEvent(analytics, "customer_data_updated")
        }
        isBothTypeContact={true}
      />
      <UBAppModal
        id="sale_expense_payment_modal"
        open={showDeleteModal}
        header={{
          handleClose: () => setShowDeleteModal(false),
          CustomHeader: (
            <ParagraphText className={"fontWeight500 fontSize16"}>
              {isSale ? I18n.delete_quick_sale : I18n.delete_expense}
            </ParagraphText>
          ),
        }}
        className={`confirmationModal ${styles.confirmationModal}`}
        footer={[
          {
            data: {
              className: `fontSize14`,
              title: I18n.cancel,
              onClick: () => setShowDeleteModal(false),
              id: "quick_sale_cancel",
            },
          },
          {
            data: {
              className: `deleteInvoiceModal`,
              title: isSale ? I18n.delete_quick_sale : I18n.delete_expense,
              onClick: handleDelete,
              id: "quick_sale_delete",
            },
          },
        ]}
      >
        <Box marginTop={1}>
          <ParagraphText className="foundationInk300Color fontSize14">
            {isSale
              ? I18n.are_you_sure_you_want_to_delete_this_quick_sale
              : I18n.are_you_sure_you_want_to_delete_this_expense}
            <span className="fontSize14 blue800Color">
              {I18n.this_action_cannot_be_undone}
            </span>
          </ParagraphText>
        </Box>
      </UBAppModal>
      <WalletNonidealModal
        isPending={false}
        setOpen={setWalletNonidealModal}
        open={walletNonidealModal}
        raastDetail={null}
        applicationID={null}
        isVerificationFailed={null}
      />
    </Grid>
  );
};

const enhance = withObservables(
  ["invoiceId", "business"],
  ({ invoiceId, business }) => {
    return {
      invoiceDetail: invoiceId ? observeInvoicesById(invoiceId) : of([]),
      orders: invoiceId
        ? observeInvoicesById(invoiceId).pipe(
          switchMap((inv) => (inv.length ? inv[0].orders.observe() : of([]))),
        )
        : of([]),

      customerDetail: invoiceId
        ? observeInvoicesById(invoiceId).pipe(
          switchMap((inv) =>
            inv.length ? inv[0].customer.observe() : of({}),
          ),
          catchError((error) => of({})),
        )
        : of({}),
      customers: business ? business?.getAllCustomers.observe() : of([]),
    };
  },
);

export default enhance(EnhancementSaleExpenseForm);
